import { Modals } from '../../context/modal/modalTypes';
import useModalState from '../../context/modal/useModalState';
import CustomModal from '../../components/CustomModal';
import CustomModalHeader from '../../components/CustomModal/CustomModalHeader';
import CustomModalContent from '../../components/CustomModal/CustomModalContent';
import ShareActions from './ShareActions';
import ShareCardBase from './ShareCardBase';
import { ReactNode, useState } from 'react';

/**
 * Base modal used to share user's PnL and Volume ranking
 */

export enum ShareModalType {
    PnL = 'pnl',
    Volume = 'volume',
    OpenPosition = 'open',
    ClosedPosition = 'closed',
}

type Props = {
    type: ShareModalType;
    modalName: keyof Modals;
    children: ReactNode;
    cardClass: string;
};

const ShareModal: React.FC<Props> = ({ type, modalName, children, cardClass }) => {
    const { closeModal } = useModalState();

    const [imageBlob, setImageBlob] = useState('');
    const [imageId, setImageId] = useState('');

    const onClose = () => {
        closeModal(modalName);
    };

    return (
        <CustomModal
            modalName={modalName}
            className='share-ranking-modal'
            onCloseCallback={() => setImageId('')}
        >
            <CustomModalHeader
                title={`Share your ${
                    ['pnl', 'volume'].includes(type) ? 'Ranking' : 'PnL'
                }`}
                onClose={onClose}
            />
            <CustomModalContent>
                <ShareCardBase
                    className={cardClass}
                    setImageId={setImageId}
                    setImageBlob={setImageBlob}
                    imageId={imageId}
                >
                    {children}
                </ShareCardBase>
                <ShareActions
                    imageId={imageId}
                    imageBlob={imageBlob}
                    type={ShareModalType.OpenPosition}
                    onClose={onClose}
                />
            </CustomModalContent>
        </CustomModal>
    );
};

export default ShareModal;
